





import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ApexOptions } from 'apexcharts';

@Component({})
export default class RegimeChart extends Vue {

	public get series() {
		return this.regime;
	}

	public get lables() {
		return [`Да - ${(this.series[0] as number).toLocaleString()}`,
		`Нет - ${(this.series[1] as number).toLocaleString()}`];
	}

	public get chartTitle() {
		return `Соблюдение режима за ${this.$store.getters['russia/getLastUpdate']}`;
	}

	public get angels() {
		const yes = this.regime[0];
		const no = this.regime[1];
		const total = yes + no;
		const noPercentage = (100 * no) / total;
		const startAngle = -90  + (noPercentage * 2);
		const endAngle = 360 - Math.abs(startAngle);
		return {
			start: startAngle,
			end: endAngle
		};
	}

	public options: ApexOptions = {
		chart: {
			type: 'donut',
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
		},
		labels: this.lables,
		legend: {
			fontSize: '18px',
			position: 'bottom',
			horizontalAlign: 'center',
		},
		colors: ['#1565c0', '#c62828'],
		title: {
			text: this.chartTitle,
			align: 'center',
			style: {
				fontWeight: 'normal',
				fontSize: '20px',
			},
		},
		dataLabels: {
			enabled: true,
			style: {
				colors: ['#373D3F'],
				fontSize: '18px',
				fontWeight: 600,
			},
			dropShadow: {
				enabled: false,
			},
		},
		plotOptions: {
			pie: {
				startAngle: this.angels.start,
				endAngle: this.angels.end,
				dataLabels: {
					minAngleToShowLabel: 0,
					offset: 50,
				},
				donut: {
					size: '60%',
					labels: {
						show: true,
						name: {
							show: true,
						},
						total: {
							show: true,
							showAlways: true,
							label: undefined,
							formatter: (val) => {
								return this.formatDigit(this.series[0] + this.series[1]);
							},
						},
					},
				},
			},
		},
	};

	public get regime(): number[] {
		return this.$store.getters['russia/getRegime'];
	}

	@Watch('series', { deep: true })
	public onSeriaesChange(val) {
		(this.$refs.regimeChart as any).updateOptions({
			labels: this.lables,
			title: {
				text: this.chartTitle,
			},
			plotOptions: {
				pie: {
					startAngle: this.angels.start,
					endAngle: this.angels.end,
				}
			}
		});
		this.$nextTick(() => {
			const totalLabel = document.querySelector('.apexcharts-text.apexcharts-datalabel-value');
			if (totalLabel) {
				const y = parseFloat(totalLabel.getAttribute('y')!);
				const alignedY = y - 18;
				totalLabel.setAttribute('y', alignedY.toString());
			}
		});
	}
	public mounted() {
		this.$nextTick(() => {
			if ((this.$refs.regimeChart as any)) {
				setTimeout(() => {
					this.$nextTick(() => (this.$refs.regimeChart as any).updateSeries(this.series));
				}, 300);
			}
		});
	}

	private formatDigit(val: number) {
		return `${val.toLocaleString()}`;
	}

}
